/**
 * Cliente del historial de bonos trimestrales PSI+ ya CONFIRMADOS (pagados) — ver
 * PsiPlusQuarterResult en psiplatform-be/prisma/supabase/schema.prisma para el ciclo de
 * vida completo (draft → frozen → confirmed/rejected). El backend solo expone acá las
 * filas `confirmed`: un trimestre en curso sigue viéndose en MetricsPsiPlusTab.tsx (cálculo
 * en vivo, sin tocar), esto es exclusivamente el histórico de trimestres ya cerrados.
 */

import { beHttp } from './beHttp';

export type PsiPlusTier = 'bronze' | 'silver' | 'gold';

export interface PsiPlusQuarterResultBe {
  quarterYear: number;
  /** 1 a 4 — trimestre calendario. */
  quarter: number;
  tierLabel: PsiPlusTier;
  tierAmountUsd: number;
  paidAt: string;
  montoEnMonedaDePago: number;
  currency: string;
  montoUsd: number;
}

/** Trimestre cerrado en el que no se llegó a ningún tramo (no se abonó bono). */
export interface PsiPlusSinBonoBe {
  quarterYear: number;
  quarter: number;
  totalEligibleUniverse5: number;
  totalEligibleUniverse10: number;
  minSessionsRequired: number;
  missingSessions: number;
}

export interface PsiPlusHistorialBeResponse {
  trimestres: PsiPlusQuarterResultBe[];
  /** Ausente en backends anteriores a este campo: tratar como []. */
  trimestresSinBono?: PsiPlusSinBonoBe[];
}

export interface PsiPlusHistorialSessionBe {
  date: string;
  patientNames: string[];
  processType: string | null;
}

export interface PsiPlusHistorialProcessBe {
  patientNames: string[];
  processType: string | null;
  totalSessions: number;
  sessionsInQuarter: number;
  eligible5InQ: number;
  eligible10InQ: number;
}

export interface PsiPlusHistorialDetailBe {
  quarterYear: number;
  quarter: number;
  outcome: 'paid' | 'not_reached';
  tierLabel: PsiPlusTier | null;
  winningUniverse: 5 | 10 | null;
  totalEligibleUniverse5: number;
  totalEligibleUniverse10: number;
  /** paid: sesiones que sustentan el bono cobrado; not_reached: ponderadas del universo 5+. */
  sessions: PsiPlusHistorialSessionBe[];
  /** Solo not_reached. */
  processes: PsiPlusHistorialProcessBe[];
}

/** GET /psychologist/psi-plus/historial. */
export function fetchPsiPlusHistorialBe(): Promise<PsiPlusHistorialBeResponse> {
  return beHttp.get<PsiPlusHistorialBeResponse>(
    '/api/psychologist/psi-plus/historial',
    undefined,
    { showErrorToast: false },
  );
}

/** GET /psychologist/psi-plus/historial/:quarterYear/:quarter — detalle de un trimestre cerrado. */
export function fetchPsiPlusHistorialDetailBe(
  quarterYear: number,
  quarter: number,
): Promise<PsiPlusHistorialDetailBe> {
  return beHttp.get<PsiPlusHistorialDetailBe>(
    `/api/psychologist/psi-plus/historial/${quarterYear}/${quarter}`,
    undefined,
    { showErrorToast: false },
  );
}
